const DEFAULT_API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.skylightagri.com/api/v1"
    : "http://localhost:3001/api/v1";

export function normalizeApiBaseUrl(value?: string | null) {
  const raw = (value?.trim() || DEFAULT_API_BASE_URL).replace(/\/+$/, "");
  if (/\/api\/v\d+$/i.test(raw)) return raw;
  if (/\/api$/i.test(raw)) return `${raw}/v1`;
  return `${raw}/api/v1`;
}

export function apiPublicOrigin() {
  return API_BASE_URL.replace(/\/api\/v\d+$/i, "").replace(/\/+$/, "");
}

export const API_BASE_URL = normalizeApiBaseUrl(
  process.env.NEXT_PUBLIC_API_BASE_URL ?? process.env.NEXT_PUBLIC_API_URL,
);

// SSR runs inside Docker, where localhost points at the web container. Keep
// the browser API URL public while allowing server-rendered pages to use the
// internal Compose service hostname.
export const SERVER_API_BASE_URL = normalizeApiBaseUrl(
  process.env.API_INTERNAL_BASE_URL ?? API_BASE_URL,
);
